export default __webpack_public_path__ + "static/media/PLU-BEERCARD-A4-6-bckg-1.4db93478.jpg";